import React, { useEffect, useState } from 'react'
import Text from '../../../elements/Typo/Text'
import { BodyTooltip } from '../../../components/BodyTooltip'
import { useTranslation } from 'react-i18next'
import { EXPERIMENT_PROGRESS_STATUS } from '../../../_config'
import Icon from '../../../components/icons'
import { formatNumberWithCommas, KMBformatNumber, trackEvent } from '../../../_common/functions'
import { ADVANCE_CONFIG_OPTION } from '../../../_common/constant'
import { ReactComponent as Confidence } from '../../../assets/svg/confidence.svg'
import ExperimentDetails from '../../ExperimentDetails'
import { IoIosArrowDown } from 'react-icons/io'
import toast from 'react-hot-toast'

interface ExperimentHeaderBarProps {
    experiment: any
    mteCardData: any
    dmlCardData: any
    setExperiments: React.Dispatch<React.SetStateAction<any>>
    activeExperimentLiteral: string | null
    showDetailsToggle: (literal: string) => void
    child: boolean
}

const ExperimentHeaderBar: React.FC<ExperimentHeaderBarProps> = ({ experiment, setExperiments, activeExperimentLiteral, showDetailsToggle, child, mteCardData, dmlCardData }) => {
    const { t } = useTranslation()
    const [kpiUnit, setKpiUnit] = useState<string>('')
    const [confidence, setConfidence] = useState<string>('')
    const [selectedDidMethodoly, setSelectedDidMethodoly] = useState<boolean>(false)

    const cardDetails = experiment?.insight?.kpiCombinations?.[0]?.cardDetails
    const cardIcon = () => {
        let iconName: any = null

        if (cardDetails?.experiment_status === EXPERIMENT_PROGRESS_STATUS.POSITIVE_LIFT) {
            iconName = 'upFilled'
        } else if (cardDetails?.experiment_status === EXPERIMENT_PROGRESS_STATUS.NEGATIVE_LIFT) {
            iconName = 'downFilled'
        }

        return iconName ? <Icon name={iconName} className="text-white" size={0.5} /> : null
    }

    const getStatusBackgroundColor = (status?: string, _selectedKPI?: any) => {
        if (status === EXPERIMENT_PROGRESS_STATUS.POSITIVE_LIFT) return '#2EA87C'
        if (status === EXPERIMENT_PROGRESS_STATUS.NEGATIVE_LIFT) return '#921A28'
        return '#c9b802'
    }

    useEffect(() => {
        if (cardDetails && experiment) {
            setKpiUnit(cardDetails.kpi_unit || '')
            if (Number(Number(cardDetails?.confidence_level).toFixed(2)) >= 100) {
                setConfidence('99.9%')
            } else {
                setConfidence((cardDetails?.confidence_level ? Number(cardDetails?.confidence_level).toFixed(2) : 0) + '%')
            }
        }
        const isDidMethodology = cardDetails?.methodology?.toLowerCase() === ADVANCE_CONFIG_OPTION.DID.value
        setSelectedDidMethodoly(isDidMethodology)
    }, [cardDetails, experiment])
    return (
        <div>
            <div className="relative flex items-center justify-between gap-3 px-2 py-[0.25rem] border border-slate-300 rounded-lg bg-slate-100 text-[0.55rem] text-slate-800">
                {child && <div className="absolute top-[50%] -left-[1.05rem] w-4 border-t-2 border border-slate-300"></div>}
                <div className="h-full flex items-center gap-3">
                    <span className="px-2 py-1 border border-gray-300 bg-slate-300 rounded-full text-[0.5rem] leading-[1.2] whitespace-nowrap">ID: {experiment?.experiment_literal}</span>
                    <span className="px-2 py-1 bg-yellow-400 text-black rounded leading-[1.2]  text-[0.5rem] font-semibold">{experiment?.exp_type_status}</span>
                    <span className="font-medium text-[0.5rem] truncate ">{experiment?.experiment_name}</span>
                </div>

                <div className="h-full flex gap-3 items-center">
                    <div className="col-span-1 relative flex items-center bg-[linear-gradient(135deg,_#d79005_0%,_#f2b006_50%,_#f8d327_100%)] rounded-[0.25rem] py-[0.25rem] px-[0.5rem] h-[2.2rem]">
                        <div className="w-full">
                            <div className="flex row items-center justify-between w-full text-[#121b28]">
                                <p className="font-medium text-[0.5rem] leading-none">{t('Uplift')}</p>
                                <div className="flex gap-2">
                                    {cardDetails?.kpi_trend_text && (
                                        <BodyTooltip text={cardDetails?.kpi_trend_text} position="top" className="flex items-center gap-1 w-full">
                                            <Icon name="question-mark" size={'0.9'} />
                                        </BodyTooltip>
                                    )}
                                    <div
                                        className={`flex flex-row rounded-[1.8rem] items-center py-[0.05rem] px-[0.2rem] ml-3 ${(cardDetails?.experiment_status?.split('_')?.join(' ')?.length || 0) < 20 ? 'w-fit' : 'w-auto'}`}
                                        style={{ backgroundColor: getStatusBackgroundColor(cardDetails?.experiment_status, experiment?.insight?.kpiCombinations?.[0].kpi) }}
                                    >
                                        <Text
                                            size="xs"
                                            title={cardDetails?.experiment_status?.split('_').join(' ') || '-'}
                                            className={`text-nowrap leading-[1] !text-[0.4rem] truncate ${cardDetails?.experiment_status == EXPERIMENT_PROGRESS_STATUS.POSITIVE_LIFT || cardDetails?.experiment_status == EXPERIMENT_PROGRESS_STATUS.NEGATIVE_LIFT ? 'text-white' : 'text-black'}`}
                                        >
                                            {cardDetails?.experiment_status?.split('_').join(' ') || '-'}
                                        </Text>
                                        {cardIcon()}
                                    </div>
                                </div>
                            </div>

                            <Text className="text-[0.8rem] font-bold truncate !leading-none mt-1" title={((cardDetails?.uplift && formatNumberWithCommas(+Number.parseFloat('' + cardDetails?.uplift).toFixed(2))) || 0) + '%'}>
                                {cardDetails?.experiment_status?.search('Inconclusive') === -1 ? (
                                    <>
                                        {cardDetails?.uplift && +cardDetails?.uplift > 0 ? '+' : ''}
                                        {(cardDetails?.uplift && formatNumberWithCommas(+Number.parseFloat('' + cardDetails?.uplift).toFixed(2))) || 0}%
                                    </>
                                ) : (
                                    <span className="text-[0.54rem] font-bold">Not Applicable</span>
                                )}
                            </Text>
                        </div>
                    </div>
                    <div className="col-span-1 relative flex items-center bg-[linear-gradient(135deg,_#d79005_0%,_#f2b006_50%,_#f8d327_100%)] rounded-[0.25rem] py-[0.25rem] px-[0.5rem] h-[2.2rem]">
                        <div className="w-full">
                            <p className="font-medium text-black flex items-center gap-2 leading-[1.2]">
                                <span className="text-[0.5rem]">{selectedDidMethodoly ? t('Average KPI Impact') : t('KPI Impact')}</span>
                                <span className="text-[0.5rem] leading-none font-medium">({cardDetails?.kpi_name || '-'})</span>
                            </p>
                            {cardDetails?.experiment_status?.search('Inconclusive') === -1 ? (
                                <p className="font-bold text-black text-[0.8rem] flex items-center gap-2 mt-1 leading-[1.2]">
                                    <span style={{ fontSize: Math.min(Math.max(0.5, 0.667 - ((KMBformatNumber(cardDetails?.kpi_impact_value) + kpiUnit).length - 10) * 0.0833), 0.667) + 'rem' }}>{KMBformatNumber(cardDetails?.kpi_impact_value)}</span>
                                    <span>{kpiUnit}</span>
                                </p>
                            ) : (
                                <p className="text-[0.54rem] font-bold leading-[1.2]">Not Applicable</p>
                            )}
                        </div>
                    </div>
                    <div className="col-span-1 relative flex items-center text-black  bg-[linear-gradient(135deg,_#d79005_0%,_#f2b006_50%,_#f8d327_100%)] rounded-[0.25rem] py-[0.25rem] px-[0.5rem] h-[2.2rem]">
                        <div className="pr-4">
                            <p className="font-medium text-[0.5rem] leading-[1.2] ">{t('Confidence')}</p>
                            <p className="text-[0.667rem] font-bold truncate !leading-[1.2] mt-1.5" title={confidence}>
                                {confidence}
                            </p>
                        </div>
                        <Confidence height={'2rem'} width={'2rem'} />
                    </div>

                    <button
                        type="button"
                        onClick={() => {
                            const isInvalid = !experiment.experiment_result
                            if (isInvalid) {
                                trackEvent('insight_experiment_row_invalid_status', {
                                    experiment_literal: experiment.experiment_literal,
                                    status: experiment.status,
                                })
                                toast.error(t('This experiment is either in progress or has failed.'))
                            } else {
                                showDetailsToggle(experiment.experiment_literal)
                                trackEvent('insight_experiment_row_toggled', {
                                    experiment_literal: experiment.experiment_literal,
                                    expanded: activeExperimentLiteral !== experiment.experiment_literal,
                                })
                            }
                        }}
                        className={`ml-auto w-4 h-4 flex items-center justify-center border border-slate-700 bg-slate-600 rounded-full text-slate-100 transition-transform ${activeExperimentLiteral === experiment?.experiment_literal ? 'rotate-180' : ''}`}
                    >
                        <IoIosArrowDown className="text-[0.8rem]" />
                    </button>
                </div>
            </div>
            {activeExperimentLiteral === experiment?.experiment_literal && (
                <div className="p-3 border border-slate-200 rounded-lg bg-slate-50 mt-2">
                    <ExperimentDetails experiment={experiment} setExperiments={setExperiments} mteCardData={mteCardData} dmlCardData={dmlCardData} />{' '}
                    {/* You can pass necessary props to ExperimentDetails component if needed  experiment={experiment}*/}
                </div>
            )}
        </div>
    )
}

export default ExperimentHeaderBar
